export function LabChevronDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" className="size-3.5" {...props}>
      <path stroke="currentColor" strokeWidth="1.16" d="m13 6-6 4-6-4" />
    </svg>
  );
}
